<template>
  <v-app>
    <v-main>
      <v-container class="fill-height" style="opacity: 0.9" fluid>
        <v-snackbar
          :timeout="snackbar.timeout"
          v-model="snackbar.show"
          top
          :color="snackbar.color"
          elevation="24"
        >
          {{ snackbar.message }}
          <template v-slot:action="{ attrs }">
            <v-btn color="black" v-bind="attrs" @click="snackbar.show = false"> Close </v-btn>
          </template>
        </v-snackbar>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-avatar size="100" style="top: 35px; z-index: 1000">
              <v-img src="@/assets/user.png"></v-img>
            </v-avatar>
            <v-card class="elevation-12">
              <v-progress-linear
                :active="loading"
                :indeterminate="loading"
                bottom
                color="white"
              ></v-progress-linear>
              <v-card-text class="mt-10">
                <v-form>
                  <v-text-field
                    label="Login"
                    prepend-icon="mdi-account-outline"
                    type="text"
                    v-model="email"
                    aria-required="true"
                  ></v-text-field>
                  <v-text-field
                    label="Password"
                    prepend-icon="mdi-form-textbox-password"
                    type="password"
                    v-model="password"
                    aria-required="true"
                    @keyup.enter="login"
                  ></v-text-field>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="login" color="primary">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  import firebase from 'firebase'
  // import { authenticate } from '../services/authService'
  /* import api from '../assets/js/api_helper' */

  export default {
    data() {
      return {
        email: '',
        password: '',
        snackbar: {
          show: false,
          timeout: 2000,
          color: 'primary',
          message: '',
        },
        loading: false,
      }
    },
    methods: {
      async login() {
        this.loading = true

        console.log(this.email, this.password)

        try {
          await firebase.auth().signInWithEmailAndPassword(this.email, this.password)
          const redirectUrl = this.$route.query.redirect_url

          if (redirectUrl) this.$router.push(redirectUrl)
          else this.$router.replace('/')
        } catch (error) {
          const validErrorCodes = [
            'auth/invalid-email',
            'auth/wrong-password',
            'auth/user-not-found',
          ]
          let message = validErrorCodes.includes(error.code)
            ? 'Invalid credentials, Please try again!'
            : 'Cannot reach authentication service!'
          this.showSnackbar('red', message)
          console.log(error)
        } finally {
          this.loading = false
        }

        /* try {
          const { data } = await authenticate(this.email, this.password)
          const redirectUrl = this.$route.query.redirect_url

          console.log(data)
          if (data && data.token) {
            if (redirectUrl) this.$router.push(redirectUrl)
            else this.$router.replace('/')
          }
        } catch (error) {
          console.log(error)
        } */
      },

      showSnackbar(type, message) {
        this.snackbar.color = type
        this.snackbar.message = message
        this.snackbar.show = true
      },
    },
  }
</script>
